import { defineComponent as _defineComponent } from 'vue'
import { useStore, useAsync } from '@nuxtjs/composition-api';
import { State } from '@/store';
import { Resource } from '@/types/resource';
import ResourcesListHorizontal from '@/components/resource/ResourcesListHorizontal.vue';

interface Props {
  title?: string;
  subheading?: string;
  link?: string;
  parentResource?: Resource;
  params?: Record<string, any>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesListHorizontalSsr',
  props: {
    title: null,
    subheading: null,
    link: null,
    parentResource: null,
    params: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  subheading?: string;
  link?: string;
  parentResource?: Resource;
  params?: Record<string, any>;
};

const $store = useStore<State>();



const loadResources = async () => {
  try {
    const response = await $store.dispatch('loadResources', props.params);
    return response.list;
  } catch (err: Error | any) {
    console.error(err);
  }
};

const resources = useAsync(
  () => {
    return loadResources();
  },
  `${JSON.stringify(props.params)}`
);

return { __sfc: true,$store, props, loadResources, resources, ResourcesListHorizontal }
}

})